export interface PostTodoTitle {
    user_id: number;
    title: string;
    deu_date: string;
}

export interface PostTodoTask {
    todo_list_id: number;
    task: string;
}

export interface TodoTitle {
    todo_list_id: number;
    title: string;
    deu_date: string;
    task: TodoTask[];
}

export const mapTodoTitle = (data:any): TodoTitle => {
    if(!data){
        throw new Error('Invalied TodoTitle type')
    }

    const TodoTitle: TodoTitle = {
        todo_list_id: data.todo_list_id,
        title: data.title,
        deu_date: data.deu_date,
        task: mapTodoTasks(data.task),
    }

    return TodoTitle;

}

export const mapTodoTitles = (data: any[]): TodoTitle[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid TodoTitle data');
    }
  
    return data.map(mapTodoTitle);
  };

  //=========================================================== TodoTask==================================
export interface TodoTask {
    todo_list_task_id: number;
    task: string;
    todo_list_task_status: number;
}

export const mapTodoTask = (data:any): TodoTask => {
    if(!data){
        throw new Error('Invalied TodoTask type')
    }

    const TodoTask: TodoTask = {
        todo_list_task_id: data.todo_list_task_id,
        task: data.task,
        todo_list_task_status: data.todo_list_task_status,
       
    }

    return TodoTask;

}

export const mapTodoTasks = (data: any[]): TodoTask[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid TodoTask data');
    }
  
    return data.map(mapTodoTask);
  };